// extracted by mini-css-extract-plugin
export var growableInput = "_67-0";
export var tagContainer = "_67-2";
export var textInput = "_67-1";